import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e556032")

_pushScopeId("data-v-0e556032")
const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "center title-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_simulation_works_form = _resolveComponent("simulation-works-form")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withId(() => [
      ($setup.loadingSimulationWorks)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (!$setup.loadingSimulationWorks)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (!$props.simulation)
              ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString($setup.t('Simulation.noDataWorks')), 1))
              : _createCommentVNode("", true),
            ($props.simulation)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  ($setup.editing)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("dig-ui-title", _hoisted_7, _toDisplayString($setup.t('Simulation.works')), 1),
                        _createVNode(_component_simulation_works_form, {
                          simulation: $props.simulation,
                          loading: $setup.loadingForm,
                          onUpdate: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateField($event))),
                          onUpdateCee: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateCee($event))),
                          onReset: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('reset')))
                        }, null, 8, ["simulation", "loading"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})